<template>
  <div>
    <div class="flex flex-col items-center justify-center gap-2">
      <BaseShapeMask shape="12-sided-cookie" animation="spin" animation-duration="10" class="p-2">
        <BaseMemberAvatar size="96" :member="member" />
      </BaseShapeMask>
      <p class="text-title-large text-center">
        {{
          $t('coaching.status.rejected.description', { firstName: memberShortName(member) })
        }}
      </p>
      <p class="text-body-large text-on-surface-variant">
        {{ $t('coaching.status.rejected.description') }}
      </p>
      <div class="mt-4 flex gap-2">
        <BaseTextButton size="M" color="outlined" icon="close" @click="openWithdrawDialog">
          {{ $t('coaching.status.rejected.button.withdraw') }}
        </BaseTextButton>
        <BaseTextButton size="M" color="tonal" icon="refresh" @click="$emit('resend')">
          {{ $t('coaching.status.rejected.button.resend') }}
        </BaseTextButton>
      </div>
    </div>
    <BaseDialog
      type="basic"
      :is-open="withdrawDialogIsOpen"
      @close="closeWithdrawDialog"
      :title="$t('coaching.status.rejected.withdrawDialog.title')"
      :description="
        $t('coaching.status.rejected.withdrawDialog.description', {
          firstName: memberShortName(member),
        })
      "
    >
      <template #confirm>
        <BaseTextButton @click="$emit('withdraw')">
          {{ $t('coaching.status.rejected.button.withdraw') }}
        </BaseTextButton>
      </template>
      <template #dismiss>
        <BaseTextButton @click="closeWithdrawDialog">
          {{ $t('common.cancel') }}
        </BaseTextButton>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts" setup>
  import BaseShapeMask from '@/core/components/base/shapes/BaseShapeMask.vue'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import type { Member } from '@/core/models/member/member'
  import { memberShortName } from '@/core/models/member/member-name'

  defineProps<{
    member: Member
  }>()

  defineEmits(['resend', 'withdraw'])

  const {
    isOpen: withdrawDialogIsOpen,
    openDialog: openWithdrawDialog,
    closeDialog: closeWithdrawDialog,
  } = useDialog()
</script>
